import { APIS, URLS } from '@/shared/config/urls';
import type { ApiResponse } from '@/shared/types/abstract-api-response';
import { request } from '@/shared/utils/request';
import type {
  AggregatedRoadData,
  LaneCountsByTime,
  LaneTrafficSummary,
  ObjectTrafficAll,
  PaginatedResponse,
  RadarObject,
  RoadTrafficSummary,
  VehicleCountByTime,
} from '../types/types-statistic';

export const fetchObject: (params: string) => Promise<ApiResponse<PaginatedResponse<RadarObject>>> =
  async (params = '') => {
    const url = `${URLS.BACK_DSH}${APIS.object(params)}`;
    return await request.get(url);
  };

export const fetchObjectTraffic: (
  params: string
) => Promise<ApiResponse<AggregatedRoadData[]>> = async (params = '') => {
  const url = `${URLS.BACK_DSH}${APIS.objectTraffic(params)}`;
  return await request.get(url);
};

export const fetchObjectTrafficAll: (
  params: string
) => Promise<ApiResponse<ObjectTrafficAll[]>> = async (params = '') => {
  const url = `${URLS.BACK_DSH}${APIS.objectTrafficAll(params)}`;
  return await request.get(url);
};

export const fetchObjectCnt: (
  params: string
) => Promise<ApiResponse<RoadTrafficSummary[]>> = async (params = '') => {
  const url = `${URLS.BACK_DSH}${APIS.objectCnt(params)}`;
  return await request.get(url);
};

export const fetchObjectCntAll: (
  params: string
) => Promise<ApiResponse<VehicleCountByTime[]>> = async (params = '') => {
  const url = `${URLS.BACK_DSH}${APIS.objectCntAll(params)}`;
  return await request.get(url);
};

export const fetchObjectCntLane: (
  params: string
) => Promise<ApiResponse<LaneTrafficSummary[]>> = async (params = '') => {
  const url = `${URLS.BACK_DSH}${APIS.objectCntLane(params)}`;
  return await request.get(url);
};

export const fetchObjectCntLaneAll: (
  params: string
) => Promise<ApiResponse<LaneCountsByTime[]>> = async (params = '') => {
  const url = `${URLS.BACK_DSH}${APIS.objectCntLaneAll(params)}`;
  return await request.get(url);
};
